import { Injectable } from '@angular/core';
import {Order, OrderWithIdent, Referral} from '../../dto/order';
import { CrudService } from '../../services';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataListModel } from '../../models/data-list-model';
import { toServerDateString, toISODateString } from '../../providers/app-date-adapter';
import { OrderLightStatus } from '../../dto/order-light-status';
import { OrderCancellationModel } from '../../models/order-cancellation-model';
import { EnumModel } from '../../models/enum-model';
import { CardReorderModel } from '../../models/card-reorder-model';
import { DateTableFilter } from '../../table-datasouces/date-table-filter';
import { PrevNextModel } from '../../models/prev-next-model';
import {ResendWebidModel} from '../../models/resend-webid-model';
import {SendUploadLinkModel} from '../../models/send-upload-link-model';
import {Card, CardConversion, CardExtension} from "../../dto/card";
import {WebIdTransaction} from '../../dto/web-id-transaction';
import {PrevNextIdModel} from '../../models/prev-next-id-model';
import {ReorderCardResult} from '../../models/reorder-card-result';
import {CardReorder} from '../../dto/cardReorder';
import {CreateCardOrderModel} from '../../models/create-card-order-model';
import {CreateCardBatchListItem} from '../../models/create-card/create-card';

@Injectable({
  providedIn: 'root'
})
export class OrdersService implements CrudService<Order> {
  readonly apiPath = 'orders/';

  constructor(private http: HttpClient) { }
  get(id: any) {
    return this.http.get(this.apiPath + id) as Observable<Order>;
  }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[]

  ): Observable<DataListModel<Order>> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    //return this.http.get(this.apiPath, { params }) as Observable<DataListModel<OrderWithIdent>>;
    // solr
    return this.http.get(this.apiPath+'search', { params }) as Observable<DataListModel<OrderWithIdent>>;
  }
  add(item: Order): Observable<Object> {
    throw new Error('Method not implemented.');
  }
  update(item: Order) {
    return this.http.put(this.apiPath, item) as Observable<Order>;
  }

  getCancellationReasons(): Observable<EnumModel[]> {
    return this.http.get(this.apiPath + 'cancellation-reasons') as Observable<EnumModel[]>;
  }

  getReorderReasons(): Observable<EnumModel[]> {
    return this.http.get(this.apiPath + 'reorder-reasons') as Observable<EnumModel[]>;
  }

  cancelOrder(orderCancellationModel: OrderCancellationModel) {
    return this.http.post(this.apiPath + orderCancellationModel.orderId + '/cancel', orderCancellationModel);
  }

  resendWebidLink(model: ResendWebidModel): Observable<WebIdTransaction> {
    // /resend-webid
    return this.http.post(this.apiPath + 'resend-webid', model) as Observable<WebIdTransaction>;
  }



  delete(id: any) {
    return this.deleteMany([id]);
  }

  restore(id: any) {
    return this.restoreMany([id]);
  }

  export(idList: any[]): Observable<HttpResponse<Blob>> {
    let httpParams = new HttpParams();
    let idListString = '';
    idList.forEach(id => {
      idListString+=id.toString()+',';
    });
    idListString = idListString.substring(0, idListString.length - 1);
    httpParams = httpParams.append('ids', idListString);

    return this.http.get(this.apiPath + 'export', { params: httpParams, responseType: 'blob', observe: 'response' });
  }

  exportToPortal(idList: any[]): Observable<CreateCardBatchListItem> {
    let httpParams = new HttpParams();
    let idListString = '';
    idList.forEach(id => {
      idListString+=id.toString()+',';
    });
    idListString = idListString.substring(0, idListString.length - 1);
    httpParams = httpParams.append('ids', idListString);

    return this.http.get(this.apiPath + 'export-to-portal', { params: httpParams, }) as Observable<CreateCardBatchListItem>;
  }

  getStatuses(idList: any[]): Observable<OrderLightStatus[]> {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('id', id.toString());
    });

    return this.http.get(this.apiPath + 'status', { params: httpParams }) as Observable<OrderLightStatus[]>;
  }

  deleteMany(idList: any[]) {
    let httpParams = new HttpParams();

    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });

    return this.http.delete(this.apiPath, { params: httpParams });
  }

  restoreMany(idList: any[]) {
    let httpParams = new HttpParams();
    idList.forEach(id => {
      httpParams = httpParams.append('list', id.toString());
    });
    return this.http.patch(this.apiPath, null, { params: httpParams });
  }

  reorderCards(model: CardReorderModel[]): Observable<ReorderCardResult[]> {
    return this.http.post(this.apiPath + 'reorder-cards', model) as Observable<ReorderCardResult[]>;
  }
  reorderCard(model: CardReorderModel): Observable<ReorderCardResult> {
    return this.http.post(this.apiPath + 'reorder-card', model) as Observable<ReorderCardResult>;
  }

  getFilterParams(filters: DateTableFilter): HttpParams {
    const str = filters.str || '';
    const dateFilterCols = filters.dateFilterCols || [];
    const startFilterDate = filters.startFilterDate || null;
    const endFilterDate = filters.endFilterDate || null;
    const companiesFilter = filters.companiesFilter || null;

    const additionalFilterData = filters.additionalFilterData || [];
    const someAdditionalData = filters.someAdditionalData || null;



    let params = new HttpParams()
      .set('filterString', str)
      .set('startFilterDate', toISODateString(startFilterDate))
      .set('endFilterDate', toISODateString(endFilterDate))
    .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }



    if (filters.sortField) {
      params = params.set('sortField', filters.sortField);
    }
    if (filters.sortDirection) {
      params = params.set('sortDirection', filters.sortDirection);
    }
    if (filters.enumFilter) {
      params = params.set('enumFilter', JSON.stringify(filters.enumFilter));
    }

    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }


    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }

    return params;
  }

  getPrev(filters: DateTableFilter, orderId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${orderId}/prev`, { params }) as Observable<number>;
  }

  getNext(filters: DateTableFilter, orderId: number): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${orderId}/next`, { params }) as Observable<number>;
  }

  getPrevNext(filters: DateTableFilter, orderId: number): Observable<PrevNextModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${orderId}/prev-next`, { params }) as Observable<PrevNextModel>;
  }

  getPrevNextIds(filters: DateTableFilter, customerId: number): Observable<PrevNextIdModel> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}${customerId}/prev-next-ids`, { params }) as Observable<PrevNextIdModel>;
  }

  /*exportAllData(filters: DateTableFilter): Observable<HttpResponse<Blob>> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}export-all`, { params: params, responseType: "blob", observe: "response" }) as Observable<HttpResponse<Blob>>;
  }*/

  getCardsQueuedForConversion(detail: boolean): Observable<CardConversion[]> {
    return this.http.get(`${this.apiPath}cards-queued-for-conversion?detail=${detail}`, {headers:{'skip-error-snack':'true'} }) as Observable<CardConversion[]>;
  }
  getCardsQueuedForConversionCount(): Observable<number> {
    return this.http.get(`${this.apiPath}cards-queued-for-conversion-count`, {headers:{'skip-error-snack':'true'} }) as Observable<number>;
  }
  getCardsQueuedForExtension(): Observable<CardExtension[]> {
    return this.http.get(`${this.apiPath}queued-extensions`, {headers:{'skip-error-snack':'true'} }) as Observable<CardExtension[]>;
  }

  getRecentCardExtensions(): Observable<CardExtension[]> {
    return this.http.get(`${this.apiPath}recent-extensions`, {headers:{'skip-error-snack':'true'} }) as Observable<CardExtension[]>;
  }

  getExportableOrdersCount(): Observable<number> {
    return this.http.get(`${this.apiPath}exportable-count`, {headers:{'skip-error-snack':'true'} }) as Observable<number>;
  }

  getUltimatelyFailedOrderStatusCount() {
    return this.http.get(`${this.apiPath}status-ultimately-failed-count`) as Observable<number>;
  }

  getExportable(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,
    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string},
    companiesFilter?: string[]

  ): Observable<DataListModel<Order>> {
    let params = new HttpParams()
      .set('page', pageIndex.toString())
      .set('pageSize', pageSize.toString())
      .set('filterString', filterString)
      .set('sortField', sortField)
      .set('sortDirection', sortDirection)
      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData);

    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }

    return this.http.get(this.apiPath + 'exportable', { params }) as Observable<DataListModel<OrderWithIdent>>;
  }

  exportExportable(filters: DateTableFilter): Observable<HttpResponse<Blob>> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}export-exportable`, { params, responseType: 'blob', observe: 'response' }) as Observable<HttpResponse<Blob>>;
  }

  sendExportableToPortal(filters: DateTableFilter): Observable<number> {
    const params = this.getFilterParams(filters);
    return this.http.get(`${this.apiPath}send-exportable-to-portal`, { params }) as Observable<number>;
  }

  blacklistAppDevice(orderId: number): Observable<any> {
    const oh = {
      do: 1,
    };
    return this.http.post(this.apiPath + orderId + '/blacklist-appdevice', oh);
  }
  unBlacklistAppDevice(orderId: number): Observable<any> {
    const oh = {
      do: 1,
    };
    return this.http.post(this.apiPath + orderId + '/un-blacklist-appdevice', oh);
  }

  getReferralForOrder(orderId: number) {
    return this.http.get(this.apiPath + orderId + '/referral') as Observable<Referral>;
  }

  getReordersQueuedCount(): Observable<number> {
    return this.http.get(this.apiPath + 'reorders-queued-count', {headers: {'skip-error-snack': 'true'}}) as Observable<number>;
  }

  getReordersQueued(page: number, pageSize: number, filterString: string|null): Observable<DataListModel<CardReorder>> {

    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if ( filterString ) {
params = params.set('filterString', filterString);
}

    return this.http.get(this.apiPath + 'reorders-queued', {params, headers: {'skip-error-snack': 'true'}}) as Observable<DataListModel<CardReorder>>;
  }

  approveReorder(reorderId: number): Observable<any> {
    return this.http.post(this.apiPath + 'reorders-queued/approve', {
      cardReorderId: reorderId,
    }, {headers: {'skip-error-snack': 'true'}}) as Observable<any>;
  }

  createInternalOrder(createCardOrder: CreateCardOrderModel) {
    return this.http.post(this.apiPath + 'create-internally',
      createCardOrder
    , {headers: {'skip-error-snack': 'true'}}) as Observable<Order>;
  }
}
